export const getDate = (selectedSlot: Record<string, any>) => {
  const date = new Date(selectedSlot?.date?.fullDate) || new Date();
  const time = selectedSlot.time || '12:00 AM';

  const month = date.toLocaleString('en-GB', {
    month: 'long'
  });
  const day = date.toLocaleString('en-GB', {
    day: 'numeric'
  });
  return `${formatOrdinals(day)} of ${month} at ${time}`;
};

export const formatOrdinals = (n: number) => {
  const pr = new Intl.PluralRules('en-US', { type: 'ordinal' });
  const suffixes = new Map([
    ['one', 'st'],
    ['two', 'nd'],
    ['few', 'rd'],
    ['other', 'th']
  ]);
  const rule = pr.select(n);
  const suffix = suffixes.get(rule);
  return `${n}${suffix}`;
};
